import { isStaging } from './environment'

export const sendGTagEvent = (params) => {
  if (isStaging) {
    console.log('pushing to dataLayer', params)
  }
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(params)
}
